// extracted by mini-css-extract-plugin
module.exports = {"centerHorizontally":"singleColumnLayout-module--center-horizontally--35pP6"};